<template>
  <section :class="$style.result">
    <header :class="[$style.result__header, $style.header]">
      <h2 :class="[$style.header__title, $style.title]">
        ユーザーの診断結果：
        <span :class="$style.title__type">{{
          diagnosisSummary.result.personality.title
        }}</span>
      </h2>
      <p :class="$style.header__text">
        {{ diagnosisSummary.result.personality.description }}
      </p>
    </header>
    <ul :class="[$style.result__analyses, $style.analyses]">
      <li
        v-for="(item, index) in analyses"
        :key="index"
        :class="$style.analyses__item"
      >
        <UserAnalysis :item="item" />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { DiagnosisSummary } from '@/types/app'
import UserAnalysis from './UserAnalysis.vue'

const props = defineProps<{
  diagnosisSummary: DiagnosisSummary
}>()

const analyses = computed(() => {
  const {
    annualIncome,
    annualSaving,
    monthlyRentCost,
    investment,
    monthlyInsurance,
  } = props.diagnosisSummary.analysis
  return [
    annualIncome,
    annualSaving,
    monthlyRentCost,
    investment,
    monthlyInsurance,
  ]
})
</script>

<style lang="scss" module>
.result {
  &__analyses {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}

.title {
  color: $color-text-and-object-high-emphasis;
  font-size: 24px;
  font-weight: bold;
  line-height: 1;

  &__type {
    color: $color-text-and-object-accent-primary;
  }
}

.header {
  &__text {
    color: $color-text-and-object-high-emphasis;
    font-size: 10px;
    line-height: 1.6;

    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.analyses {
  display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(3, 232px);
  grid-template-rows: repeat(2, minmax(264px, auto));

  &__item {
    padding: 20px 24px 24px;
    background-color: $color-surface-primary;
    border-radius: $border-radius-v2-rounder;
    box-shadow: $shadow-20;
  }
}
</style>
